<template>
  <div id="mapDiv">

  </div>
</template>

<script>
export default {
  name: 'map',
  data() {
    return {
      // PI:3.14159265358979324,
      // map: null,
      // zoom: 18
    }
  },
  mounted() {
    // this.initMap();
  },
  methods: {
    // initMap() {
    //   var T=window.T;
    //   this.map = new T.Map('mapDiv', {
    //       projection: 'EPSG:4326'
    //   });
    //   this.map.centerAndZoom(new T.LngLat(120.1530,30.1813), this.zoom);
      
    //   //创建标注对象
    //   const marker = new T.Marker(new T.LngLat(120.1530,30.1813));
    //   //向地图上添加标注
    //   this.map.addOverLay(marker);
    // }
  }
}
</script>

<style scoped>
 #mapDiv{
    width:84%;
    height:600px;
    margin-bottom: 0.4rem;
    background: url('../../assets/images/map.png');
  }
/* @media screen and (min-width: 768px) and (max-width: 1920px) {
  #mapDiv{
    width:84%;
    height:600px;
    margin-bottom: 0.4rem;
  }
}
@media screen and (max-width: 768px) {
  #mapDiv{
    width:80%;
    height:600px;
    margin-bottom: 0.4rem;
  }
} */
</style>